import API_ENV from './API_ENV';
import { unionFlag } from '@utils';

export const OK = 0;

const envMap = {
  dev: `-${'test05'}`,
  development: `-${'test05'}`,
  test05: `-${API_ENV}`,
  stage: `.${API_ENV}`,
  prd: "",
  production: "",
};

export const bfdApi = `//${unionFlag()}-corp${envMap[API_ENV]}.dongfangfuli.com`;